var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-404"},[_c('div',{staticClass:"title"},[_vm._v(" Sorry, this content is not available yet ")]),_c('div',{staticClass:"button",on:{"click":_vm.back}},[_vm._v(" back ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }